import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { AXIS, GRID, TOOLTIP_STYLE } from './ChartCard.js';

interface Row {
  label: string;
  current: number | null;
  prior: number | null;
}

/**
 * Income comparison grouped bars (chart #5). With `showPrior` (default true) it
 * overlays the prior-year series; set it false for the 5-year view, where each
 * bar is already a different year and there is no prior overlay.
 */
export function MonthlyYoYChart({
  data,
  anio,
  showPrior = true,
}: {
  data: Row[];
  anio: number;
  showPrior?: boolean;
}) {
  return (
    <ResponsiveContainer width="100%" height={280}>
      <BarChart data={data} margin={{ top: 8, right: 12, bottom: 8, left: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke={GRID} />
        <XAxis dataKey="label" tick={AXIS} />
        <YAxis tick={AXIS} />
        <Tooltip contentStyle={TOOLTIP_STYLE} />
        <Legend wrapperStyle={{ fontSize: 12 }} />
        {showPrior && <Bar dataKey="prior" name={`${anio - 1}`} fill="#64748b" />}
        <Bar dataKey="current" name={showPrior ? `${anio}` : 'Ingreso'} fill="#3b82f6" />
      </BarChart>
    </ResponsiveContainer>
  );
}
